import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Column } from 'seagull';
import styles from './MessageFrame.module.scss';
export const MessageFrame = (param)=>{
    let { children, padding = 16, fillHeight = false, testId } = param;
    return /*#__PURE__*/ _jsx(Column, {
        gap: 12,
        padding: padding,
        width: "100%",
        className: cn(styles.frame, {
            [styles.fillHeight]: fillHeight
        }),
        testId: testId,
        children: children
    });
};
